import { Icon, IconSize } from '@bechtel/gds';
import { FC } from 'react';
import { IconProps } from '../../types';

export const IconStarSolid: FC<IconProps> = ({ handleClick }) => {
  return (
    <Icon icon="star" style={{ cursor: 'pointer' }} iconStyle={'solid'} size={IconSize.LARGE} onClick={handleClick} />
  )
}